<template>
    <v-layout row wrap>
        <v-flex xs0 sm2 md3 lg4 />
        <v-flex xs12 sm8 md6 lg4>
            <slot />
        </v-flex>
        <v-flex xs0 sm2 md3 lg4 />
        <v-flex xs12 class="full_content">
            <v-layout row wrap>
                <v-flex xs12 sm6 md8 class="custom_flex_data">
                    <h3 class="custom_text_add_field">
                        Saisie des contenus
                    </h3>
                    <v-layout class="publish_btn">
                        <v-flex xs12>
                            <v-btn class="custom_btn_add_field custom_btn_color_blue"
                                   @click="addNewContent">
                                Ajouter un contenu
                            </v-btn>
                        </v-flex>
                    </v-layout>
                    <v-text-field v-model="mode" type="number" filled mask="#" label="Mode (0, 1, 2)" />
                    <v-expansion-panels class="custom_expansion_panel">
                        <v-expansion-panel v-for="(item,i) in currentRaDomContent" :key="i">
                            <v-expansion-panel-header>Contenu {{ i }}</v-expansion-panel-header>
                            <v-expansion-panel-content>
                                <ra-dom-item :index="i" />
                            </v-expansion-panel-content>
                        </v-expansion-panel>
                    </v-expansion-panels>
                    <v-layout class="publish_btn">
                        <v-flex xs6 />
                        <v-flex xs6>
                            <v-btn class="custom_btn_add_field custom_btn_color_blue"
                                   @click="updateAction">
                                Publier les changements
                            </v-btn>
                        </v-flex>
                    </v-layout>
                </v-flex>
                <v-flex x0 sm6 md4 class="custom_flex_data">
                    <h3 class="custom_text_add_field">
                        Image à scanner
                    </h3>
                    <p v-if="imageToScan" class="custom_text_add_field_p">
                        Testez votre story en scannant cette image depuis votre téléphone
                    </p>
                    <p v-else class="custom_text_add_field_p">
                        Pour tester votre augmentation, veuillez ajouter une image dans l'onglet Paramètres.
                    </p>
                    <v-img v-if="imageToScan" :src="imageToScan" aspect-ratio="1" class="grey lighten-2">
                        <template v-slot:placeholder>
                            <v-layout fill-height align-center justify-center ma-0>
                                <v-progress-circular indeterminate color="grey lighten-5" />
                            </v-layout>
                        </template>
                    </v-img>
                </v-flex>
            </v-layout>
        </v-flex>
    </v-layout>
</template>

<script>
    import { mapGetters, mapActions } from 'vuex';
    import RaDomItem from './raDom/RaDomItem';

    export default {
        name: 'RaDom',
        components: { RaDomItem },
        computed: {
            ...mapGetters('actions/raDom', ['currentRaDomContent']),
            mode: {
                get () {
                    return this.$store.state.actions.raDom.currentRaDom.mode;
                },
                set (mode) {
                    this.$store.commit('actions/raDom/SET_DATA_MODE', { mode });
                }
            },
            imageToScan: function () {
                return this.$store.state.actions.augmentation.image_id
                    ? '/image/' + this.$store.state.actions.augmentation.image_id : null;
            }
        },
        mounted () {
            this.emitVerification();
        },
        methods: {
            ...mapActions('actions/raDom', ['raDomUpdate', 'addContent']),
            emitVerification: function () {
                this.$emit('verificationValues', {
                    state: true,
                    data: {}
                });
            },
            updateAction: function () {
                this.raDomUpdate().then(() => {
                    this.$toasted.success('Changement correctement pris en compte.');
                }).catch((err) => {
                    this.$toasted.error(err);
                });
            },
            addNewContent: function () {
                this.addContent().catch((err) => {
                    this.$toasted.error(err);
                });
            }
        }
    };
</script>

<style scoped>
    .layout {
        width: 100%;
        margin: 0;
    }

    #ra_dom_section .full_content {
        background-color: rgba(0, 0, 0, 0.05);
        padding: 10px 20px 20px 20px !important;
        min-height: calc(100vh - 215px);
    }

    .custom_text_add_field {
        margin-right: 10px;
        width: 100%;
        margin-bottom: 15px;
        text-align: center;
        margin-top: 10px;
    }

    .custom_flex_data {
        padding-left: 20px !important;
        padding-right: 20px !important;
    }

    .publish_btn {
        position: relative;
    }

    .publish_btn button {
        width: 100%;
        color: white !important;
        font-weight: 600 !important;
        text-transform: initial !important;
    }

    .custom_expansion_panel {
        text-align: left;
    }

    .custom_expansion_panel > div:last-child {
        width: 100%;
        margin-bottom: 20px;
    }

</style>
